import { render, staticRenderFns } from "./FloatingActionButton.vue?vue&type=template&id=03ae334a"
import script from "./FloatingActionButton.vue?vue&type=script&lang=js"
export * from "./FloatingActionButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingActionButton.vue?vue&type=style&index=0&id=03ae334a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports